import { useEffect, useState } from "react";
import {
  BiBuildingHouse,
  BiLocationPlus,
  BiSolidFlag,
  BiSolidMessage,
  BiSolidZap,
  BiUserCircle,
} from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { PhoneInput } from "react-international-phone";
import { Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { statesArray } from "../../data";
import GeneralButton from "../button/GeneralButton";
import FormInput from "../formInput/FormInput";

const EditBillingAddressModal = ({ modal, toggle, billingData, onSave }) => {
  const handleSave = () => {
    onSave(data);
  };
  const [data, setData] = useState(billingData ?? {});

  useEffect(() => {
    if (billingData) {
      setData(billingData ?? {});
    }
  }, [billingData]);
  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalBody className="p-0 border-0">
        <div className="d-flex mb-1 justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
          <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
            <BiLocationPlus className="text-primary mr-2" /> Edit Address
          </h5>
          <IoCloseSharp size={24} className="text-muted pointer hover-opacity-75" onClick={toggle} style={{ cursor: "pointer" }} />
        </div>
        <Row className="mb-0 p-3">
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Enter Name"}
              className={" sales__inputCustomer"}
              placeholder={"Enter  name"}
              value={data?.first_name}
              handleChange={(e) => {
                setData({
                  ...data,
                  first_name: e.target.value,
                });
              }}
              icon={<BiUserCircle size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Last Name"}
              className={" sales__inputCustomer"}
              placeholder={"Enter  name"}
              value={data?.last_name}
              handleChange={(e) => {
                setData({
                  ...data,
                  last_name: e.target.value,
                });
              }}
              icon={<BiUserCircle size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Company Name"}
              className={" sales__inputCustomer"}
              placeholder={"Enter Company name"}
              value={data?.company}
              handleChange={(e) => {
                setData({
                  ...data,
                  company: e.target.value,
                });
              }}
              icon={
                <BiBuildingHouse size={"20"} style={{ color: "#B0B0B0" }} />
              }
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"EIN"}
              className={" sales__inputCustomer"}
              placeholder={"Enter EIN"}
              value={data?.EIN || data?.ein || ""}
              handleChange={(e) => {
                setData({
                  ...data,
                  EIN: e.target.value,
                });
              }}
              icon={
                <BiBuildingHouse size={"20"} style={{ color: "#B0B0B0" }} />
              }
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Address Line1"}
              placeholder={"Enter Address Line1"}
              className={`  sales__inputCustomer }`}
              value={data?.address_1}
              handleChange={(e) => {
                setData({
                  ...data,
                  address_1: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Address Line2"}
              placeholder={"Enter Address Line2"}
              className={`  sales__inputCustomer }`}
              value={data?.address_2}
              handleChange={(e) => {
                setData({
                  ...data,
                  address_2: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"Country"}
              placeholder={"Enter Country"}
              className={`  sales__inputCustomer }`}
              value={data?.country}
              handleChange={(e) => {
                setData({
                  ...data,
                  country: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />
            {/* <FormInput
              dropdown={true}
              type={"select"}
              label={"Country"}
              placeholder={"Enter Country"}
              className={` sales__inputCustomer`}
              options={countriesList}
              value={countriesList?.find((i) => i?.countryCode === countryCode)?.label}
              showSearch={true}
              handleChange={(e, value) => {
                setCountryCode(value?.countryCode);
                setData({
                  ...data,
                  country: value?.countryCode,
                });
              }}
              icon={
                <BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />
              }
            /> */}
          </Col>
          <Col md={4}>
            <FormInput
              dropdown
              type={"select"}
              label={"State"}
              placeholder={"Enter State"}
              className={`  sales__inputCustomer }`}
              options={statesArray}
              showSearch={true}
              value={data?.state}
              handleChange={(value) => {
                setData({
                  ...data,
                  state: value,
                });
              }}
              icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
            />
            {/* <FormInput
              dropdown
              type={"select"}
              label={"State"}
              placeholder={"Enter State"}
              className={`  sales__inputCustomer }`}
              options={statesList}
              showSearch={true}
              value={statesList?.find((i) => i?.stateCode === stateCode)?.label}
              handleChange={(e, value) => {
                setStateCode(value?.stateCode);
                setData({
                  ...data,
                  state: value?.stateCode,
                });
              }}
              icon={
                <BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />
              }
            /> */}
          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"City"}
              placeholder={"Enter City"}
              className={`  sales__inputCustomer }`}
              value={data?.city}
              handleChange={(e) => {
                setData({
                  ...data,
                  city: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />
            {/* <FormInput
              dropdown
              type={"select"}
              label={"City"}
              placeholder={"Enter City"}
              className={`  sales__inputCustomer }`}
              options={cities}
              showSearch={true}
              value={data?.city}
              handleChange={(e, value) => {
                setData({
                  ...data,
                  city: e,
                });
              }}
              icon={<BiBuilding size={"20"} style={{ color: "#B0B0B0" }} />}
            /> */}
          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"Post Code"}
              placeholder={"Enter Post Code"}
              value={data?.postcode}
              handleChange={(e) => {
                setData({
                  ...data,
                  postcode: e.target.value,
                });
              }}
              className={`  sales__inputCustomer }`}
              icon={<BiSolidZap size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"Email"}
              placeholder={"Enter Email"}
              value={data?.email}
              handleChange={(e) => {
                setData({
                  ...data,
                  email: e.target.value,
                });
              }}
              className={`  sales__inputCustomer }`}
              icon={<BiSolidMessage size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={4}>
            <Label className="fw-bold">Phone</Label>
            <PhoneInput
              placeholder="Enter phone number"
              value={data?.phone}
              style={{ width: "100%" }}
              onChange={(e) => {
                setData({
                  ...data,
                  phone: e,
                });
              }}
            />
          </Col>
          <div className="d-flex justify-content-end">
            <GeneralButton
              title={"Cancel"}
              className={"white-button mx-2"}
              width={"180px"}
              handleClick={() => {
                onSave(billingData);
                toggle();
              }}
            />
            <GeneralButton
              title={"Save"}
              className={"blue-button"}
              width={"180px"}
              handleClick={handleSave}
            />
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
const EditShippingAddressModal = ({
  modal,
  toggle,
  shippingData,
  setShippingData,
  onSave,
  handleShippingSave,
}) => {
  const [data, setData] = useState(shippingData ?? {});
  const handleSave = () => {
    handleShippingSave(data);
  };
  useEffect(() => {
    if (shippingData) {
      setData(shippingData ?? {});
    }
  }, [shippingData]);
  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalBody className="p-5">
        <h4 className="primary-color mb-3">Edit Address</h4>
        <Row className="mb-3">
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Enter Name"}
              className={" sales__inputCustomer"}
              placeholder={"Enter  name"}
              value={data?.first_name}
              handleChange={(e) => {
                setData({
                  ...data,
                  first_name: e.target.value,
                });
              }}
              icon={<BiUserCircle size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Last Name"}
              className={" sales__inputCustomer"}
              placeholder={"Enter  name"}
              value={data?.last_name}
              handleChange={(e) => {
                setData({
                  ...data,
                  last_name: e.target.value,
                });
              }}
              icon={<BiUserCircle size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={12}>
            <FormInput
              type={"text"}
              label={"Company Name"}
              className={" sales__inputCustomer"}
              placeholder={"Enter Company name"}
              value={data?.company}
              handleChange={(e) => {
                setData({
                  ...data,
                  company: e.target.value,
                });
              }}
              icon={
                <BiBuildingHouse size={"20"} style={{ color: "#B0B0B0" }} />
              }
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Address Line1"}
              placeholder={"Enter Address Line1"}
              className={`  sales__inputCustomer }`}
              value={data?.address_1}
              handleChange={(e) => {
                setData({
                  ...data,
                  address_1: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Address Line2"}
              placeholder={"Enter Address Line2"}
              className={`  sales__inputCustomer }`}
              value={data?.address_2}
              handleChange={(e) => {
                setData({
                  ...data,
                  address_2: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"Country"}
              placeholder={"Enter Country"}
              className={`  sales__inputCustomer }`}
              value={data?.country}
              handleChange={(e) => {
                setData({
                  ...data,
                  country: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />
            {/* <FormInput
              dropdown={true}
              type={"select"}
              label={"Country"}
              placeholder={"Enter Country"}
              className={` sales__inputCustomer`}
              options={countriesList}
              value={countriesList?.find((i) => i?.countryCode === countryCode)?.label}
              showSearch={true}
              handleChange={(e, value) => {
                setCountryCode(value?.countryCode);
                setData({
                  ...data,
                  country: value?.countryCode,
                });
              }}
              icon={
                <BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />
              }
            /> */}
          </Col>
          <Col md={4}>
            <FormInput
              dropdown
              type={"select"}
              label={"State"}
              placeholder={"Enter State"}
              className={`  sales__inputCustomer }`}
              options={statesArray}
              showSearch={true}
              value={data?.state}
              handleChange={(value) => {
                setData({
                  ...data,
                  state: value,
                });
              }}
              icon={<BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />}
            />
            {/* <FormInput
              dropdown
              type={"select"}
              label={"State"}
              placeholder={"Enter State"}
              className={`  sales__inputCustomer }`}
              options={statesList}
              showSearch={true}
              value={statesList?.find((i) => i?.stateCode === stateCode)?.label}
              handleChange={(e, value) => {
                setStateCode(value?.stateCode);
                setData({
                  ...data,
                  state: value?.stateCode,
                });
              }}
              icon={
                <BiSolidFlag size={"20"} style={{ color: "#B0B0B0" }} />
              }
            /> */}
          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"City"}
              placeholder={"Enter City"}
              className={`  sales__inputCustomer }`}
              value={data?.city}
              handleChange={(e) => {
                setData({
                  ...data,
                  city: e.target.value,
                });
              }}
              icon={<BiLocationPlus size={"20"} style={{ color: "#B0B0B0" }} />}
            />

          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"Post Code"}
              placeholder={"Enter Post Code"}
              value={data?.postcode}
              handleChange={(e) => {
                setData({
                  ...data,
                  postcode: e.target.value,
                });
              }}
              className={`  sales__inputCustomer }`}
              icon={<BiSolidZap size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={4}>
            <FormInput
              type={"text"}
              label={"Email"}
              placeholder={"Enter Email"}
              value={data?.email}
              handleChange={(e) => {
                setData({
                  ...data,
                  email: e.target.value,
                });
              }}
              className={`  sales__inputCustomer }`}
              icon={<BiSolidMessage size={"20"} style={{ color: "#B0B0B0" }} />}
            />
          </Col>
          <Col md={4}>
            <Label className="fw-bold">Phone</Label>
            <PhoneInput
              placeholder="Enter phone number"
              value={data?.phone}
              style={{ width: "100%" }}
              onChange={(e) => {
                setData({
                  ...data,
                  phone: e,
                });
              }}
            />
          </Col>
          <div className="d-flex justify-content-end">
            <GeneralButton
              title={"Cancel"}
              className={"white-button mx-2"}
              width={"260px"}
              handleClick={() => {
                onSave(shippingData);
                toggle();
              }}
            />
            <GeneralButton
              title={"Save"}
              className={"blue-button"}
              width={"260px"}
              handleClick={handleSave}
            />
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export { EditBillingAddressModal, EditShippingAddressModal };

